
import Vue from 'vue';

interface Props {
  data: {
    isLoggedIn: boolean;
    profile: {
      displayName: string | null;
      id: number;
      email: string;
      firstName: string | null;
      lastName: string | null;
    };
  };
  openLoginModal: () => void;
}

interface Methods {
  scrollToPaywall: () => void;
}

export default Vue.extend<unknown, Methods, unknown, Props>({
  props: {
    data: {
      type: Object,
      required: true,
    },
    openLoginModal: {
      type: Function,
      required: true,
    },
  },
  methods: {
    scrollToPaywall() {
      const paywall = document.querySelector('#omp-page') as HTMLElement;
      paywall.scrollIntoView({ behavior: 'smooth' });
    },
  },
});
